import { Inject, Injectable, Injector } from '@angular/core';

import { FootprintApiManager_FlowService } from './FootprintApiManager.flow.index';
import { SPSCommerce_FlowService } from './SPSCommerce.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintApiManager = this.injector.get(FootprintApiManager_FlowService);
    this.SPSCommerce = this.injector.get(SPSCommerce_FlowService);
  }

    public FootprintApiManager: FootprintApiManager_FlowService;
    public SPSCommerce: SPSCommerce_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
